/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $User = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        username: {
            type: 'string',
            isRequired: true,
        },
        variant: {
            type: 'string',
            isRequired: true,
        },
        givenName: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        familyName: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        photo: {
            type: 'any-of',
            contains: [{
                type: 'Image',
            }, {
                type: 'null',
            }],
        },
        blocked: {
            type: 'boolean',
            isRequired: true,
        },
        insiderScore: {
            type: 'number',
            isRequired: true,
        },
        badges: {
            type: 'array',
            contains: {
                type: 'UserBadge',
            },
            isRequired: true,
        },
        playerId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        sports: {
            type: 'SportEnum',
            isRequired: true,
        },
        email: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        tel: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        pro: {
            type: 'boolean',
            isRequired: true,
        },
        adFree: {
            type: 'boolean',
            isRequired: true,
        },
        emailConfirmed: {
            type: 'boolean',
            isRequired: true,
        },
        telConfirmed: {
            type: 'boolean',
            isRequired: true,
        },
        anonymous: {
            type: 'boolean',
            isRequired: true,
        },
        deleted: {
            type: 'boolean',
            isRequired: true,
        },
        language: {
            type: 'Language',
            isRequired: true,
        },
        groups: {
            type: 'array',
            contains: {
                type: 'Group',
            },
            isRequired: true,
        },
        tournaments: {
            type: 'array',
            contains: {
                type: 'UserTournament',
            },
            isRequired: true,
        },
        scopes: {
            type: 'array',
            contains: {
                type: 'Scope',
            },
            isRequired: true,
        },
        areaOfInterest: {
            type: 'AreaOfInterest',
            isRequired: true,
        },
        selectedMyTeamId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        myTeams: {
            type: 'array',
            contains: {
                type: 'TeamListMinimum',
            },
            isRequired: true,
        },
        player: {
            type: 'any-of',
            contains: [{
                type: 'PlayerListElement',
            }, {
                type: 'null',
            }],
        },
        agbLevel: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        newsletter: {
            type: 'boolean',
            isRequired: true,
        },
        googleOAuth: {
            type: 'boolean',
            isRequired: true,
        },
        appleOAuth: {
            type: 'boolean',
            isRequired: true,
        },
        note: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
